<template>
  <section>
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title" style="justify-content: center">Solicitação Finalizada</v-card-title>
            <v-row style="justify-content: center">
              <p>Solicitação realizada com sucesso!</p>
            </v-row>
            <v-row style="justify-content: center">
                <a @click="setNovaSolicitacao"><v-icon small color="blue">call_made</v-icon>Criar nova solicitação</a>
            </v-row>
            <v-row style="justify-content: center">
              <router-link to="/carteira-macrorregiao/entidade/solicitacoes">
                <a><v-icon small color="blue">call_made</v-icon>Acesse a Lista de Solicitações para visualizar</a>
              </router-link>
            </v-row>
            <br>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>

import {mapActions} from "vuex";

const actions = mapActions('siePedidos', ['setFormStep']);
export default {
  name: "SolicitacaoCriada",

  methods:{
    setNovaSolicitacao(){
      this.setFormStep(1)
    },
    ...actions
  }
}

</script>

